import { Component, OnInit, Inject } from '@angular/core';
import { NgForm } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';
import { UsermanagementService } from "../Shared/usermanagement.service"
import { CommonmastersService } from "../../commonmasters/commonmasters.service";
import { DateAdapter } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToasterserviceService } from "../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../utility/shared/toastpayload";

@Component({
  selector: 'app-usermanagement',
  templateUrl: './usermanagement.component.html',
  styleUrls: ['./usermanagement.component.css']
})
export class UsermanagementComponent implements OnInit {

  staff: any; 
  BranchList:any[]=[];
  DesignationList:any[]=[];
  RoleList: any[] = [];
  AddButtonText: string;
  ErrorText: string;
  readonlyTextBox: boolean = false;
  toast : Toastpayload;

  constructor(private router: Router, private route: ActivatedRoute,
    public usermanagementService : UsermanagementService,
    private dateAdapter: DateAdapter<Date>,
    private commonmastersService: CommonmastersService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toasterserviceService: ToasterserviceService,
    public dialogRef: MatDialogRef<UsermanagementComponent>) { }

  ngOnInit() {
    // this.route.params.subscribe(params => {
    //   this.StaffNo = +  params['Id'];  // (+) converts string 'id' to a number
    // });
   
    this.resetForm();
    this.GetDesignation();
    this.Roles();

    if (this.data.DesignationId == 0) {
      this.usermanagementService.selectedUser.Id = 0;
      this.usermanagementService.selectedUser.EmployeeId = + this.data.Id;
      this.usermanagementService.selectedUser.Flag = 4;
      this.usermanagementService.selectedUser.IsActive = true;
      this.readonlyTextBox = true;
      this.AddButtonText = "Save";
    }
    else {
      // this.usermanagementService.selectedUser.Id = +this.StaffNo;
      this.usermanagementService.selectedUser.EmployeeId = + this.data.Id;
      this.usermanagementService.selectedUser.DesignationId = + this.data.DesignationId;
      this.usermanagementService.selectedUser.RoleId = + this.data.RoleId;
      this.usermanagementService.selectedUser.Flag = 4; //  -- Staff role management.
      this.usermanagementService.selectedUser.IsActive = true;
      this.usermanagementService.selectedUser.IsRoleManagement = true;
      this.readonlyTextBox = true;
      this.AddButtonText = "Change";

    //  this.GetStaffByStaffId();
    }   
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();
      this.usermanagementService.selectedUser = {
        Id: 0,
        UserId: 0,
        DesignationId: 0,
        RoleId:0,
        Password: null,
        ModulesId: 0,
        FromDate : null,
        ToDate : null,
        IsTerminated:false,
        TerminatedDate: new Date(),
        Default  : false,
        EmployeeId: 0,
        EmployeeBranchId: 0,
        CompanyId: 0,
        SaasId: null,
        CreatedDate: null,
        ModifiedDate: null,
        IsActive  : false,
        Flag : 0,
        IsRoleManagement:true,
        OldPassword: null,
    }
  }

  onSubmit() {

    if (this.usermanagementService.selectedUser.DesignationId != 0) {
      this.usermanagementService.IUDUser(this.usermanagementService.selectedUser)
        .toPromise().then(data => {

          // error due to Password was null
          this.toast = {
            message: "No Message Now!",
            title: 'Role Management',
            ic: {
              timeOut: 3000,
              closeButton: true,
            } as IndividualConfig,
            type: 'success',
          };
      
          if (data.ResponseStatus === '500') {
      
            this.toast.message = 'Role saving unsucessful, Please add User name and password!'
            this.toast.type = 'error';
            this.toasterserviceService.showToast(this.toast);
          }

          this.router.navigate(['/stafflist']);
      
        })
    }
    // this.router.navigate(['/stafflist']);
    this.dialogRef.close();
   
  }

  GetDesignation() {
    this.commonmastersService.GetDesignationList().subscribe(data => {
       this.DesignationList = data;
    })
  }

  checkTermination(checked) {
    if (!checked) {
      this.readonlyTextBox = true;
    } else {
      this.readonlyTextBox = false;
    }
  }

  Roles() {
    this.commonmastersService.GetRoleList().subscribe(data => {
      this.RoleList = data;
    })
  }

}
